const tabTriggers = document.querySelectorAll('.js_oraEvTabs__nav__btn')
const tabs = document.querySelectorAll('.oraEvTabs__tab')

tabTriggers.forEach((trigger) => {
    const tab = trigger.getAttribute('data-tab')

    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        // change active class for menu
        [...tabTriggers].map((x) =>
            x.dataset.tab === tab
                ? x.classList.add('oraEvTabs__nav__btn--active')
                : x.classList.remove('oraEvTabs__nav__btn--active')
        );

        // change active class for tabs
        [...tabs].map((x) =>
            x.dataset.tab === tab
                ? x.classList.add('oraEvTabs__tab--active')
                : x.classList.remove('oraEvTabs__tab--active')
        );
    });
});

/**
 * Triggers a tab if URL hash matches a tab with that trigger
 */
const triggerTabFromId = (id) => {
    if (!id) {
        return;
    }

    const trigger = document.querySelector(`.js_oraEvTabs__nav__btn[data-tab="${id}"]`)

    if (!trigger) {
        return
    }

    trigger.click()
}

const triggerZapMapTabsFromMenu = (e) => {
    const hash = e.target.hash

    if (!hash) {
        return
    }

    triggerTabFromId(hash.replace('#', ''))

    document.querySelector('.oraEvTabs').scrollIntoView({
        behavior: 'smooth',
    });
}

window.addEventListener('DOMContentLoaded', () => {
    triggerTabFromId(window.location.hash.replace('#', ''))

    const zapMapsTabsEl = document.querySelector('.js_oraEvTabs--zapMap')

    if (zapMapsTabsEl) {
        const zapMapMenuTriggers = document.querySelectorAll('.js_zapMapTabTrigger')
        zapMapMenuTriggers.forEach((t) => {
            t.addEventListener('click', triggerZapMapTabsFromMenu)
        })
    }
})
